module.exports = __webpack_public_path__ + "img/11.ea0e43cf.jpg";